import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgActionFormula = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M12.107 4.026h-1.032c-.841 0-1.49.643-1.49 1.438v5.523h2.522v2.026H9.585v5.523C9.585 20.448 7.976 22 6.032 22H5v-2.026h1.032c.841 0 1.49-.643 1.49-1.438v-5.523H5v-2.026h2.522V5.464C7.522 3.552 9.13 2 11.075 2h1.032v2.026Zm3.17 12.315 1.365-2.085H19l-.2.304-2.346 3.581 2.328 3.555.2.304h-2.357l-.058-.086-1.29-1.973-1.288 1.973-.058.086h-2.357l2.525-3.859-2.343-3.58-.2-.305h2.358l1.364 2.085Zm-6.033 3.154c.064-.201.11-.41.133-.626l-.052.324c-.022.102-.05.203-.081.302Zm1.49-15.634a1.706 1.706 0 0 0 .167-.023l-.167.023Zm-4.528 16.3.167-.022c.041-.008.08-.02.12-.03a1.761 1.761 0 0 1-.287.053Z"
    />
  </svg>
);
export default SvgActionFormula;
